import {
  UPDATE_USER,
} from './constants'

export function updateUser (userId, data) {
  return (dispatch, getState, { mapmy }) => {
    return dispatch({
      type: UPDATE_USER,
      payload: mapmy.updateUser(userId, data),
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/user/actions.js